import PlayersListNotFoundError from './players-list-not-found-error';
import {PlayersList as DraftkingsGolfPlayersList} from 'desktop/sites/draftkings/golf/players-list';
import {PlayersList as DraftkingsF1PlayersList} from 'desktop/sites/draftkings/f1/players-list';
import {PlayersList as DraftkingsNbaPlayersList} from 'desktop/sites/draftkings/nba/players-list';
import {PlayersList as DraftkingsNflPlayersList} from 'desktop/sites/draftkings/nfl/players-list';
import {PlayersList as DraftkingsMlbPlayersList} from 'desktop/sites/draftkings/mlb/players-list';
import {PlayersList as DraftkingsNascarPlayersList} from 'desktop/sites/draftkings/nascar/players-list';
import {PlayersList as DraftkingsMmaPlayersList} from 'desktop/sites/draftkings/mma/players-list';
import {PlayersList as DraftkingsNhlPlayersList} from 'desktop/sites/draftkings/nhl/players-list';
import {PlayersList as DraftkingsCfbPlayersList} from 'desktop/sites/draftkings/cfb/players-list';
import {PlayersList as DraftkingsLolPlayersList} from 'desktop/sites/draftkings/lol/players-list';
import {PlayersList as FanduelGolfPlayersList} from 'desktop/sites/fanduel/golf/players-list';
import {PlayersList as FanduelNbaPlayersList} from 'desktop/sites/fanduel/nba/players-list';
import {PlayersList as FanduelNflPlayersList} from 'desktop/sites/fanduel/nfl/players-list';
import {PlayersList as FanduelMlbPlayersList} from 'desktop/sites/fanduel/mlb/players-list';
import {PlayersList as FanduelNascarPlayersList} from 'desktop/sites/fanduel/nascar/players-list';
import {PlayersList as FanduelNhlPlayersList} from 'desktop/sites/fanduel/nhl/players-list';
import {PlayersList as FanduelCfbPlayersList} from 'desktop/sites/fanduel/cfb/players-list';
import {PlayersList as FanduelMmaPlayersList} from 'desktop/sites/fanduel/mma/players-list';
import {PlayersList as FanduelLolPlayersList} from 'desktop/sites/fanduel/lol/players-list';
import {PlayersList as YahooNflPlayersList} from 'desktop/sites/yahoo/nfl/players-list';
import {PlayersList as DraftkingsTennisPlayersList} from 'desktop/sites/draftkings/tennis/players-list';

const factoriesMap = {
    draftkings: {
        cfb: DraftkingsCfbPlayersList,
        f1: DraftkingsF1PlayersList,
        golf: DraftkingsGolfPlayersList,
        lol: DraftkingsLolPlayersList,
        mlb: DraftkingsMlbPlayersList,
        mma: DraftkingsMmaPlayersList,
        nascar: DraftkingsNascarPlayersList,
        nba: DraftkingsNbaPlayersList,
        nfl: DraftkingsNflPlayersList,
        nhl: DraftkingsNhlPlayersList,
        tennis: DraftkingsTennisPlayersList,
    },
    fanduel: {
        cfb: FanduelCfbPlayersList,
        golf: FanduelGolfPlayersList,
        lol: FanduelLolPlayersList,
        mlb: FanduelMlbPlayersList,
        mma: FanduelMmaPlayersList,
        nascar: FanduelNascarPlayersList,
        nba: FanduelNbaPlayersList,
        nfl: FanduelNflPlayersList,
        nhl: FanduelNhlPlayersList,
    },
    yahoo: {
        nfl: YahooNflPlayersList,
    },
};

const PlayersListFactory = {
    getComponent(sportConfig) {
        const site = sportConfig.getSite().toLowerCase();
        const sport = sportConfig.getSport().toLowerCase();

        try {
            return factoriesMap[site][sport].get(sportConfig);
        } catch (e) {
            if (e instanceof TypeError) {
                throw new PlayersListNotFoundError(`Undefined Player's List for ${site}/${sport}`);
            }
            throw e;
        }
    },
};

export default PlayersListFactory;
